import { SortDestinationColorSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-destination";
import { SortDispositionSchema } from "@redotech/redo-fulfillment-wms-common/schema/sort-disposition";
import { inventoryRuleConditionsSchema } from "@redotech/redo-inventory-common/inventory-rules/conditions";
import { sortDestinationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const updateSortDestination = {
  name: "updateSortDestination" as const,
  input: z.object({
    id: sortDestinationIdFormat.schema,
    name: z.string().optional(),
    disposition: SortDispositionSchema.nullable().optional(),
    conditions: inventoryRuleConditionsSchema.nullable().optional(),
    color: SortDestinationColorSchema.optional(),
  }),
  output: z.object({
    priority: z.number().int().nullable(),
    conditions: inventoryRuleConditionsSchema.nullable(),
    disposition: SortDispositionSchema.nullable(),
  }),
};
